import _createClass from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/**
 * Electronic Codebook block mode.
 */
import { BlockCipherMode } from './cipher-core.js';
export var ECB = /*#__PURE__*/function (_BlockCipherMode) {
  _inherits(ECB, _BlockCipherMode);

  var _super = _createSuper(ECB);

  function ECB() {
    _classCallCheck(this, ECB);

    return _super.apply(this, arguments);
  }

  return ECB;
}(BlockCipherMode);

ECB.Encryptor = /*#__PURE__*/function (_ECB) {
  _inherits(_class, _ECB);

  var _super2 = _createSuper(_class);

  function _class() {
    _classCallCheck(this, _class);

    return _super2.apply(this, arguments);
  }

  _createClass(_class, [{
    key: "processBlock",
    value: function processBlock(words, offset) {
      this._cipher.encryptBlock(words, offset);
    }
  }]);

  return _class;
}(ECB);

ECB.Decryptor = /*#__PURE__*/function (_ECB2) {
  _inherits(_class2, _ECB2);

  var _super3 = _createSuper(_class2);

  function _class2() {
    _classCallCheck(this, _class2);

    return _super3.apply(this, arguments);
  }

  _createClass(_class2, [{
    key: "processBlock",
    value: function processBlock(words, offset) {
      this._cipher.decryptBlock(words, offset);
    }
  }]);

  return _class2;
}(ECB);